
export enum Type {
    Info = 'Info',
    Term = 'Term',
    UpdateTerms = 'AddTerm'
}